export default __webpack_public_path__ + "static/media/pexels-photo-6097762.f2ff7982.jpeg";